import { Component } from '@angular/core';

@Component({
    selector: 'app-report-tabs',
    templateUrl: './report-tabs.component.html',
    styleUrls: [],
    standalone: false
})

export class ReportTabsComponent {

  routes: object[];

  constructor() {
    this.routes = [
      { label: 'Resultados', link: '/accounting/reports/total', enable: true },
      { label: 'Flujo de caja', link: '/accounting/reports/cash-flow', enable: true },
      { label: 'Fondo de maniobra', link: '/accounting/reports/working-capital', enable: true },
      { label: 'Margen bruto', link: '/accounting/reports/gross-margin', enable: true },
      // { label: 'Ratios', link: '/accounting/reports/ratio', enable: true },
    ];
  }

}
